import {
  HttpRequest
} from "../utils/request.js";
let api = {
  //InviteReject
  InviteReject: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/TeamMember/InviteReject",
      data: datas
    });
  },
  //CancelApply
  InviteApproved: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/TeamMember/InviteApproved",
      data: datas
    });
  },
  //CancelApply
  CancelApply: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/TeamMember/CancelApply",
      data: datas
    });
  },
  getWechatBindToMobilePhoneCode(data) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Account/GetWechatBindToMobilePhoneCode",
      data: data
    });
  },
  authenticateByWechat(data) {
    return HttpRequest.getRequest({
      method: "POST",
      url: "/api/TokenAuth/AuthenticateByWechat",
      data: data
    });
  },
  bindWechatUserToMobilePhoneAccount(data) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/Account/BindWechatUserToMobilePhoneAccount",
      data: data
    });
  },
  //teamQuit
  teamQuit: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/TeamMember/Quit",
      data: datas
    });
  },
  //ApplyCreate
  applyCreate: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/TeamMember/ApplyCreate",
      data: datas
    });
  },
  //teamCancel
  teamCancel: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/Team/Cancel",
      data: datas
    });
  },
  //banner
  pcBanner: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/CmsAdvertisement/GetAdvertisementList",
      data: datas
    });
  },
  // // 分站列表
  getOrgList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Org/GetOrgList",
      data: datas
    });
  },
  // //最新消息
  getCmsContentList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/CmsContent/GetCmsContentList",
      data: datas
    });
  },
  //消息详情
  getCmsContentDetail: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/CmsContent/GetCmsContentDetail",
      data: datas
    });
  },
  //基金项目
  getProjectList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Project/GetProjectList",
      data: datas
    });
  },
  //基金项目详情
  getProjectDetail: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Project/GetProjectDetail",
      data: datas
    });
  },

  //点赞
  thumbUp: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/ContentThumb/ThumbUp",
      data: datas,
      isParams: true
    });
  },
  //我创建的团队--
  getMyTeamList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Team/GetMyTeamList",
      data: datas
    });
  },
  //获取所有领域
  getAllValuesByKeys: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/management/EnumKeyValueService/GetAllValuesByKeys",
      data: datas
    });
  },
  //获取所有领域
  teamSave: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/Team/Save",
      data: datas
    });
  },
  //团体解散原因
  teamDisband: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/Team/Disband",
      data: datas
    });
  },
  //我加入的团体
  getMyJoinTeamList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Team/GetMyJoinTeamList",
      data: datas
    });
  },
  //邀请我的团体
  getInviteTeamList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Team/GetInviteTeamList",
      data: datas
    });
  },
  //我邀请的团员
  getMyInviteTeamMemberList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/TeamMember/GetMyInviteTeamMemberList",
      data: datas
    });
  },
  //我加入的团体
  getAllApprovedTeamList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Team/GetAllApprovedTeamList",
      data: datas
    });
  },
  //团体细节
  getDetail: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Team/GetDetail",
      data: datas
    });
  },
  //团队成员
  getTeamMemberList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/TeamMember/GetTeamMemberList",
      data: datas
    });
  },
  // 申请审核驳回
  applyReject: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/TeamMember/ApplyReject",
      data: datas
    });
  },
  // 申请审核通过
  applyApproved: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/TeamMember/ApplyApproved",
      data: datas
    });
  },
  //收藏列表
  getActivityCollectList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/ContentCollect/GetActivityCollectList",
      data: datas
    });
  },
  //取消收藏
  cancelCollect: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/ContentCollect/CancelCollect",
      data: datas,
      isParams: true
    });
  },
  //分享感悟
  getActivityFeelingList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/ActivityFeeling/GetActivityFeelingList",
      data: datas
    });
  },
  //活动列表
  getActivityTranslateList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Activity/GetActivityTranslateList",
      data: datas
    });
  },
  //获取地点接口
  getActivityDetail: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Activity/GetActivityDetail",
      data: datas
    });
  },
  //提交
  activityFeelingManagement: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/management/ActivityFeelingManagement/Save",
      data: datas
    });
  },
  // 建议类型
  getAllValuesByKey: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/management/EnumKeyValueService/GetAllValuesByKey",
      data: datas
    });
  },
  // 自定义Url
  getByUrl: function (url, datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: url,
      data: datas
    });
  },
  // 活动列表
  getActivityList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Activity/GetActivityList",
      data: datas
    });
  },
  // 活动门票
  getActivityTicketList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/ActivtiyTicket/GetActivityTicketList",
      data: datas
    });
  },
  // 活动自定义表单
  getActivityApplyForm: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/ActivityApply/GetActivityApplyForm",
      data: datas
    });
  },
  // 活动自定义表单
  getManagementActivityApplyForm: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/management/ActivityApplyManagement/GetActivityApplyForm",
      data: datas
    });
  },
  // 活动报名
  activitySignUp: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/ActivityApply/SignUp",
      data: datas
    });
  },
  // 评论列表
  getCommentList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Comment/GetCommentList",
      data: datas
    });
  },

  // 提交建议
  insertSuggestion: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/Suggestion/InsertSuggestion",
      data: datas
    })
  },
  // 新增评论
  getInsertComment: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/Comment/InsertComment",
      data: datas
    });
  },
  // 志愿者信息
  getVolunteerProfile: function (datas, unLogin = false) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Volunteer/GetVolunteerProfile",
      data: datas,
      unLogin: unLogin.unLogin
    });
  },
  // 个人信息
  getUserProfileBySelf: function (datas, unLogin = false) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/UserProfile/GetUserProfileBySelf",
      data: datas,
      unLogin: unLogin.unLogin
    });
  },
  // 修改个人信息
  updateProfileBySelf: function (datas) {
    return HttpRequest.getRequest({
      method: "put",
      url: "/api/services/app/UserProfile/UpdateProfileBySelf",
      data: datas
    });
  },
  getSiteMessageList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/SiteMessageRecord/GetSiteMessageList",
      data: datas
    });
  },
  getSiteMessageDetail: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/SiteMessageRecord/GetSiteMessageDetail",
      data: datas
    });
  },
  getUnreadCount: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/SiteMessageRecord/GetUnreadCount",
      data: datas
    });
  },
  // 根据栏目编号获取栏目详情
  getCmsCategoryDetail: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/CmsCategory/GetCmsCategoryDetail",
      data: datas
    });
  },
  // 生成limitToken
  generate: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/VerificationCodeLimitToken/Generate",
      data: datas
    });
  },
  // 注册时验证码
  getVerificationCode: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Volunteer/GetVerificationCode",
      data: datas
    });
  },
  //   重置密码的验证码
  getResetPasswordVerificationCode: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/UserProfile/GetResetPasswordVerificationCode",
      data: datas
    });
  },
  // 非实名注册
  ApplyAsUnofficial: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/Volunteer/ApplyAsUnofficial",
      data: datas
    });
  },
  // 实名注册
  ApplyAsOfficial2: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/Volunteer/ApplyAsOfficial2",
      data: datas
    });
  },
  //注册成功登录
  AuthenticateByToken: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/TokenAuth/AuthenticateByToken",
      data: datas
    });
  },
  // 志愿者自定义表单
  getExtensionDefinition: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Volunteer/GetExtensionDefinition",
      data: datas
    });
  },
  // 登录
  authenticate: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/TokenAuth/Authenticate",
      data: datas
    });
  },
  // 重置密码
  resetPassword: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/Account/ResetPasswordByVerificationCode",
      data: datas
    });
  },
  // 重置密码
  getLastestApplyData: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Volunteer/GetLastestApplyData",
      data: datas
    });
  },
  // 志愿者申请状态
  getVolunteerApplyStatus: function (datas, unLogin = true) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Volunteer/GetVolunteerApplyStatus",
      data: datas,
      unLogin: unLogin
    });
  },
  // 修改密码
  changePassword: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/Account/ChangePassword",
      data: datas
    });
  },
  // 获取合作方
  getFriendLinkList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/CmsFriendLinks/GetFriendLinkList",
      data: datas
    });
  },
  // // 数据字典
  // getAllValuesByKey:function (datas) {
  //   return HttpRequest.getRequest({
  //     method: "get",
  //     url: "/api/services/management/EnumKeyValueService/GetAllValuesByKey",
  //     data: datas,

  //   });
  // },
  // 提交合作方
  cooperatorApplySave: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/CooperatorApply/Save",
      data: datas
    });
  },
  //  个人积分
  getPointRecordBySelf: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Point/GetPointRecordBySelf",
      data: datas
    });
  },
  //  积分列表
  getPointRecordDetailBySelf: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Point/GetPointRecordDetailBySelf",
      data: datas
    });
  },
  //  收藏
  collect: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/ContentCollect/Collect",
      data: datas,
      isParams: true
    });
  },
  //感悟详情
  getfellDetail: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/ActivityFeeling/GetDetail",
      data: datas,
    });
  },
  //邀请列表
  getVolunteerList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/Volunteer/GetVolunteerList",
      data: datas,
    });
  },
  //邀请
  InviteCreate: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/TeamMember/InviteCreate",
      data: datas,
    });
  },
  getPersonalRank: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/VolunteerServiceHistoryRank/GetPersonalRank",
      data: datas
    });
  },
  // 我报名的活动
  getMyActivityList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/ActivityApply/GetMyActivityList",
      data: datas
    });
  },
  // 活动补签
  retroactiveSave: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/ActivitySignInRefillApplyService/Save",
      data: datas
    });
  },
  // 问卷列表
  getQuestionList: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/PollQuestion/GetQuestionList",
      data: datas
    });
  },
  // 提交问卷
  submitPollAnswer: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/PollAnswer/SubmitPollAnswer",
      data: datas
    });
  },
  // 效验邀请
  isInvitiaonLinkValid: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/CooperatroInvitation/IsInvitiaonLinkValid",
      data: datas,
      isParams: true
    });
  },
  // 效验邀请
  getItemsByEnumId: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/SelectListItem/GetItemsByEnumId",
      data: datas,
    });
  },
  // 效验邀请
  cancelSignUp: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/ActivityApply/CancelSignUp",
      data: datas,
      isParams: true
    });
  },
  LoadActvityFeeling: function (datas) {
    return HttpRequest.getRequest({
      method: "post",
      url: "/api/services/app/ActivityFeeling/LoadActvityFeeling",
      data: datas,
      isParams: true
    });
  },
  // 项目进展
  getProjectProgress: function (datas) {
    return HttpRequest.getRequest({
      method: "get",
      url: "/api/services/app/ContentMapping/GetProjectProgress",
      data: datas,
    });
  },

};
export default api;



// WEBPACK FOOTER //
// ./src/api/config.js